import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { MyWorkService } from '../services/sections/job/my-work.service';
import { JobBriefInfo } from '../models/my-work/job-brief-info.model';

@Injectable({
	providedIn: 'root'
})
export class MyWorkJobBriefInfoResolver implements Resolve<Observable<JobBriefInfo[]>> {

	constructor(
		private router: Router,
		private myWorkService: MyWorkService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.myWorkService.getBriefMyWorkJobs(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
